import { useState } from 'react'
import { useSelector } from 'react-redux'

import Button from '../../../common/Button'
import { getCaseRelatedPatientsCHUSA, searchPatientByName } from '../../../../lib/fetchApi'
import InputWithButton from '../../../common/interactive/InputWithButton'
import AddRelatedPatient from './AddRelatedPatient'
import OutsideClickComponent from '../../../fragments/OutsideClickComponent'

import classes from './FindRelatedChusaPatient.module.css'

export default function FindRelatedChusaPatient() {

    const userToken = useSelector(state => state.user.token)
    const activeCase = useSelector(state => state.case.activeCase) 

    const [isLoading, setisLoading] = useState(false)
    const [searchLoading, setSearchLoading] = useState(false)
    const [isSearchOpened, setIsSearchOpened] = useState(false)

    const [searchFound, setSearchFound] = useState(false)

    const openRelatedPatiensSearch = async () => {
        setisLoading(true)
        let relatedPatients = await getCaseRelatedPatientsCHUSA(userToken, activeCase.case.id)
        if (relatedPatients && relatedPatients.length > 0) {
            setSearchFound(relatedPatients)
        }
        setIsSearchOpened(prevState => prevState = !prevState)
        setisLoading(false)
    }

    const searchPatientHandler = async (event) => {
        event.preventDefault()
        setSearchLoading(true)

        const fd = new FormData(event.target)

        const data = Object.fromEntries(fd.entries())

        if (data.search_related_patient !== '') {            
            let search = await searchPatientByName(userToken, data.search_related_patient)
            setSearchFound(search)

        } 

        event.target.reset()
        setSearchLoading(false)
    }

    function closeRelatedModal() {
        setSearchFound(null)
        setIsSearchOpened(false)
    }

    return <div className={classes.container}>
        <div className={classes.container_inner}>
            <div>
                <h3>
                    Shared with:
                    <Button click={openRelatedPatiensSearch} btnStyle={'btn_small'} isLoading={isLoading} bypassisCaseArchived={true}>Find Patients</Button>
                </h3>
                <p><small>Other cases that use the same CHUSA</small></p>
            </div>
        </div>

        {isSearchOpened && <OutsideClickComponent task={closeRelatedModal}>
            <div className={classes.search_modal_container_wrapper}>
                <div className={classes.search_modal_container}>
                    <form onSubmit={searchPatientHandler}>
                        <InputWithButton label={'Search Patient'} name={'search_related_patient'} type={'text'} buttonIcon={'ti ti-search'}  isLoading={searchLoading}/>    
                    </form>    
                    {/* <RelatedPatientsSearchResults closeModal={closeRelatedPatiensSearch}/> */}

                    {searchFound && searchFound.length && <div className={classes.items_found}>
                        {searchFound.map(item => (
                            <AddRelatedPatient key={item.id} patientData={item} closeSearch={closeRelatedModal}/>
                        ))}    
                    </div>}
                </div>           
            </div>    
        </OutsideClickComponent>}
    </div>
}